function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 1.2a.7.7 0 01.7-.7h8.393a.7.7 0 010 1.399H1.699a.7.7 0 01-.699-.7zm7.694 3.497H1.699a.7.7 0 100 1.399h6.995a.7.7 0 000-1.4zM7.295 8.893H1.7a.7.7 0 100 1.4h5.596a.7.7 0 100-1.4zM5.896 13.09H1.7a.7.7 0 000 1.4h4.197a.7.7 0 100-1.4zm8.89-1.895a.7.7 0 00-.993 0l-.902.909V1.199a.7.7 0 10-1.4 0v10.905l-.901-.91a.702.702 0 00-.994.994l2.099 2.098a.7.7 0 00.993 0l2.098-2.098a.7.7 0 000-.993z",
  fill: "#54585D"
}))));